import { StyleSheet } from 'aphrodite';
import { charmGray, shuffleGray, white } from '../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		height: 'auto',
		backgroundColor: white,
		paddingBottom: 30,
	},
	stickyHeader: {
		position: 'sticky' as const,
		top: 0,
		zIndex: 5,
		backgroundColor: white,
	},
	tabListWrapper: {
		flexShrink: 0,
		backgroundColor: white,
		marginBottom: 20,
		borderBottom: `1px solid ${shuffleGray}`,
	},
	tabScrollOuter: {
		position: 'relative' as const,
	},
	tabScrollContainer: {
		overflowX: 'auto' as const,
		scrollbarWidth: 'none' as const,
		'::-webkit-scrollbar': {
			display: 'none',
		},
	},
	tabScrollChevron: {
		alignItems: 'center',
		border: 'none',
		bottom: 0,
		cursor: 'pointer',
		display: 'flex',
		position: 'absolute' as const,
		top: 0,
	},
	tabScrollChevronRight: {
		background: `linear-gradient(to right, transparent, ${white} 40%)`,
		paddingLeft: 24,
		paddingRight: 12,
		right: 0,
	},
	tabScrollChevronLeft: {
		background: `linear-gradient(to left, transparent, ${white} 40%)`,
		left: 0,
		paddingLeft: 12,
		paddingRight: 24,
	},
	tabScrollChevronIcon: {
		animationName: {
			'0%, 100%': { transform: 'translateX(0)' },
			'40%': { transform: 'translateX(5px)' },
			'70%': { transform: 'translateX(1px)' },
		},
		animationDuration: '0.55s',
		animationIterationCount: 3,
		animationTimingFunction: 'ease-in-out',
		color: charmGray,
		display: 'block',
	},
	tabScrollChevronIconLeft: {
		transform: 'scaleX(-1)',
		animationName: {
			'0%, 100%': { transform: 'scaleX(-1) translateX(0)' },
			'40%': { transform: 'scaleX(-1) translateX(5px)' },
			'70%': { transform: 'scaleX(-1) translateX(1px)' },
		},
	},
	tabList: {
		display: 'flex',
		minHeight: 40,
	},
	integrationsSearchInput: {
		marginBottom: 20,
		maxWidth: 400,
		width: '100%',
	},
	placeholderContent: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: 400,
		color: '#999',
		fontSize: 18,
	},
	content: {
		minWidth: 1118,
	},
	unauthorized: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		height: 400,
		gap: 8,
	},
	contentCalendarButton: {
		alignItems: 'center',
		background: 'none',
		border: 'none',
		color: charmGray,
		cursor: 'pointer',
		display: 'flex',
		fontSize: 14,
		gap: 8,
		padding: '16px 16px 8px 16px',
		':hover': {
			backgroundColor: '#f7fafc',
		},
	},
});
